/* Tice Nits: offertepagina's. Eén sectie voor vier sjablonen: keuzepagina, offerte voor een groep, voor een bedrijf en voor borduren op locatie.
   Op de keuzepagina stuurt ?voor=groep, ?voor=bedrijf of ?voor=locatie door naar de juiste pagina (oude knoppen blijven werken).
   Op een offertepagina worden velden die niet bij de soort horen verborgen en uitgeschakeld (niet meegestuurd). */
(function () {
  function init(root) {
    if (root.__tnxOfferte) return;
    root.__tnxOfferte = true;
    var mode = root.getAttribute('data-mode') || 'kies';
    if (mode === 'kies') {
      var q = new URLSearchParams(window.location.search).get('voor');
      var url = (q === 'groep' || q === 'bedrijf' || q === 'locatie') ? root.getAttribute('data-url-' + q) : '';
      if (url && !(window.Shopify && window.Shopify.designMode)) window.location.replace(url);
      return;
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-for]'), function (el) {
      var on = (' ' + el.getAttribute('data-for') + ' ').indexOf(' ' + mode + ' ') !== -1;
      el.hidden = !on;
      Array.prototype.forEach.call(el.querySelectorAll('input, select, textarea'), function (i) {
        i.disabled = !on;
        if (i.hasAttribute('data-req')) i.required = on;
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-voor-blok]'), function (b) { b.hidden = b.getAttribute('data-voor-blok') !== mode; });
  }
  function boot() { document.querySelectorAll('[data-tnx-offerte]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
